<template>
    <NavBar :bgcolor="product.color">
        <template v-slot:title>
            <span class="nav-title">新华数藏·藏品详情</span>
        </template>
    </NavBar>
    <van-overlay :show="true" v-if="show">
        <van-loading class="log" type="spinner" size="30" />
    </van-overlay>
    <div class="show_page_error" v-if="!show && tokenInvalid">
      <div class="page_error_content">
<!--        <div class="page_error_close"></div>-->
        <div class="page_error_text">
          <div>您查看的链接已失效</div>
          <div style="font-size: 12px;">如需查找相关内容请进入新华数藏首页</div>
        </div>
        <div class="page_error_btn" @click="goHome"></div>
      </div>
    </div>
    <template v-if="!show && !tokenInvalid">
        <img src="@/assets/images/watermark.png" alt="" class="watermark" v-if="watermark">
        <ShowCase class="show-case" :cover="product.cover"
                  :intensity="product.intensity"
                  :background="product.background"
                  :exhibition="product.exhibition"
                  :otherImages="product.model_mapping"
                  :container="product.type == types.container"
                  :productKey="product.id" :music="product.music">
        </ShowCase>
        <main class="bg-color" :style="{backgroundColor: product.color, zIndex: 3}">
            <div class="detail-box">
                <div class="name">{{ product.name }}</div>
                <div class="xl-list" v-if="product.tags.length">
                    <span class="item" v-for="tag in product.tags" :key="tag.name">{{ tag.name }}</span>
                </div>
            </div>

            <div class="attention" v-if="false">
                <div class="left-content">
                    <img :src="product.organization.logo" alt="" />
                    <section>
                        <p class="text-title">{{ product.organization.name }}</p>
                        <p class="text-num">作品：{{ product.organization.products_count }}</p>
                    </section>
                </div>

                <div class="right-btn" :style="{color: product.color}" @click="toggleOrganizationSubscribe">
                    {{ organizationSubscribe ? '取消关注' : '关注' }}
                </div>
            </div>

            <div class="blindbox" v-if="product.type == types.container">
                <img src="@/assets/images/blindbox-title.png" class="title">
                <div class="box">
                    <template v-for="index in 9" :key="index">
                        <img src="@/assets/images/blindbox-active.png" class="item" v-if="index == blindboxSelected">
                        <img src="@/assets/images/blindbox.png" class="item" v-else @click="changeBlindbox(index)">
                    </template>
                </div>
            </div>
            <div class="cp-status">
                <div class="f-status">{{ product.price > 0 ? '¥ ' + product.price : '免费领取' }}</div>
                <div class="xianl">{{ product.stock_show ? '剩余' : '限量' }} {{ product.stock_show ? product.stock : product.total }}</div>
            </div>
            <div class="sell-time">开售时间 {{ dateFormat('YYYY-mm-dd HH:ii:ss', product.release_time) }}</div>
            <div class="xhl-info" @click="supportShow = true">
                <div class="xhl-le">
                    <div>官方授权 限量发行｜新华·星火链技术支持</div>
                </div>
                <van-icon color="#fff" size="12" name="arrow" />
            </div>
            <div class="raffle" v-if="product.raffle">
                <p class="title">抽签流程</p>
                <div class="timeline" :class="{atonce: ! product.raffle.timeline.inform}">
                    <div class="header">
                        <span class="item" :class="{active: product.raffle.subscribe_start_active}">开放预约</span>
                        <span class="item" :class="{active: product.raffle.subscribe_end_active}">预约结束</span>
                        <span class="item" :class="{active: product.raffle.inform_active}">中签公布</span>
                        <span class="item" :class="{active: product.raffle.priority_active}">优先购买</span>
                        <span class="item" :class="{active: product.raffle.release_active}">正式抢购</span>
                    </div>
                    <div class="line">
                        <div class="item" :class="{active: product.raffle.subscribe_start_active}"></div>
                        <div class="item" :class="{active: product.raffle.subscribe_end_active}"></div>
                        <div class="item" :class="{active: product.raffle.inform_active}"></div>
                        <div class="item" :class="{active: product.raffle.priority_active}"></div>
                        <div class="item" :class="{active: product.raffle.release_active}"></div>
                    </div>
                    <div class="time">
                        <div class="item">
                            <p class="top">{{ dateFormat('mm-dd', product.raffle.timeline.subscribe_start) }}</p>
                            <p class="bottom">{{ dateFormat('HH:ii', product.raffle.timeline.subscribe_start) }}</p>
                        </div>
                        <div class="item">
                            <p class="top">{{ dateFormat('mm-dd', product.raffle.timeline.subscribe_end) }}</p>
                            <p class="bottom">{{ dateFormat('HH:ii', product.raffle.timeline.subscribe_end) }}</p>
                        </div>
                        <div class="item">
                            <p class="top">{{ dateFormat('mm-dd', product.raffle.timeline.inform) }}</p>
                            <p class="bottom">{{ dateFormat('HH:ii', product.raffle.timeline.inform) }}</p>
                        </div>
                        <div class="item">
                            <p class="top">{{ dateFormat('mm-dd', product.raffle.timeline.priority) }}</p>
                            <p class="bottom">{{ dateFormat('HH:ii', product.raffle.timeline.priority) }}</p>
                        </div>
                        <div class="item">
                            <p class="top">{{ dateFormat('mm-dd', product.raffle.timeline.release) }}</p>
                            <p class="bottom">{{ dateFormat('HH:ii', product.raffle.timeline.release) }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tips-title-cp">藏品介绍</div>
            <div class="field-container">
                <div class="field-content" id="cangpinIMG">
                    <div class="cp-detail">
                        <div class="cangpin-content">
                            <img :src="product.introduce" />
                        </div>
                        <!-- <div class="cp-info">
                <div>发行方</div>
                <div class="publish"></div>
                </div> -->
                    </div>
                </div>
            </div>

            <div class="tips-title-cp">藏品信息</div>

            <div class="field-container">
                <div class="field-content" id="cangpinIMG2">
                    <div class="field">
                        <div class="field-ri" v-if="product.organization_show">
                            <div class="field-author">创作者</div>
                            <div class="field-name publisher-name">{{ product.organization.name }}</div>
                        </div>
                        <div class="field-ri" v-if="product.issuer_show">
                            <div class="field-author">发行方</div>
                            <div class="field-name publisher-name">{{ product.issuer.name }}</div>
                        </div>
                        <div class="field-ri field-ri-end">
                            <div class="field-author">发行日期</div>
                            <div class="field-name fx-date">{{ dateFormat('YYYY-mm-dd', product.release_time) }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="tips-title-cp">{{ product.price > 0 ? '购买须知' : '免费领取须知' }}</div>

            <div class="field-container">
                <div class="field-content">
                    <div class="tips-words" v-if="product.price > 0">
                        数字藏品为虚拟商品，而非实物，在区块链上具备唯一性和稀缺性。商品一经售出，不支持退换，平台暂无转赠功能。购买前请先注册认证并登录平台，以保证藏品顺利发放至您的账户。用户不得将数字藏品用于任何商业用途。我们坚决抵制对数字藏品进行任何形式的价格炒作、场外交易、欺诈，或以任何非法方式进行使用。平台保留追究法律责任的权利。
                    </div>
                    <div class="tips-words" v-else>
                        本次发布的数字藏品均为限量免费领取。所有作品一经领取，不支持退换，平台暂无转赠功能。领取前请先注册认证并登录平台，以保证藏品顺利发放至您的账户。用户不得将数字藏品用于任何商业用途。我们坚决抵制对数字藏品进行任何形式的价格炒作、场外交易、欺诈，或以任何非法方式进行使用。平台保留追究法律责任的权利。
                    </div>
                </div>
            </div>

            <recommend v-if="false"></recommend>

            <!-- 底层链技术 -->
            <img class="xhl-logo" src="@/assets/images/xhl-logo.png" alt="" />
        </main>

        <van-overlay :show="successType == 'common'" class="success-overlay">
            <div class="common">
                <img src="@/assets/images/close-detail-toast.png" class="close" @click="successType = ''">
                <p class="title">恭喜您成功抢到</p>
                <router-link :to="'/entity/' + entityKey" class="button">查看详情</router-link>
            </div>
        </van-overlay>

        <van-overlay :show="successType == 'unpack'" class="success-overlay">
            <div class="unpack">
                <img src="@/assets/images/blindbox.png" class="blindbox">
                <p class="title">藏品盲盒</p>
                <a href="javascript:;" class="button" @click="successType = 'confirm'">打开盲盒</a>
                <img src="@/assets/images/close.png" class="close" @click="successType = ''">
            </div>
        </van-overlay>
        <van-overlay :show="successType == 'confirm'" class="success-overlay">
            <div class="confirm">
                <img :src="openEntity.product.cover" class="cover">
                <p class="title">恭喜获得</p>
                <p class="title">{{openEntity.product.name}}</p>
                <a href="javascript:;" @click="$store.state.openEntity = true;$router.push('/entity/' + openEntity.id)" class="button">查看详情</a>
            </div>
        </van-overlay>
        <van-overlay :show="showInformResult" class="success-overlay">
            <div class="common inform-result">
                <img src="@/assets/images/close-detail-toast.png" class="close" @click="showInformResult = false">
                <template v-if="product.raffle.is_hint">
                    <div class="title">
                        <p>恭喜您!</p>
                        <p>获得优先购买权益</p>
                        <p class="normal">请您于{{ dateFormat('m月d日HH:ii', product.raffle.timeline.priority) }}至{{ dateFormat('m月d日HH:ii', product.raffle.timeline.release) }}期间进行购买，逾期视为自动放弃购买权益</p>
                    </div>
                </template>
                <template v-else>
                    <div class="title">
                        <p>很遗憾未中签</p>
                        <p class="normal">*您可以在{{ dateFormat('m月d日 HH:ii', product.raffle.timeline.release) }}时进行统一抢购</p>
                    </div>
                </template>
                <div class="button" @click="showInformResult = false">我知道了</div>
            </div>
        </van-overlay>
        <!-- 底部按钮 -->
        <div class="footer-info" v-if="! show" :style="{backgroundColor: product.color}">
            <div class="share" v-if="client.xinhua" @click="arouseShare">
                <img src="@/assets/images/product-share.png">
                <span>分享</span>
            </div>
            <template v-if="product.raffle">
                <span class="btn-loot-all subscribe active hollow" v-if="product.state == states.normal && ! product.raffle.release_active" @click="purchase">
                    <div>
                        <p class="title" :style="{color: product.color}">优先购买</p>
                        <p class="subtitle tip" :style="{color: product.color}">请于{{ dateFormat('mm-dd HH:ii', product.raffle.timeline.release) }}前完成购买</p>
                    </div>
                </span>
                <div class="btn-loot-all active in-app"
                     :style="{'color': product.color}"
                     @click="purchase"
                     v-else-if="product.state == states.normal">
                    <div v-if="product.price > 0">
                        <p class="title">马上抢</p>
                        <p class="subtitle tip" v-if="!client.xinhua">在新华网客户端内购买</p>
                    </div>
                    <div v-else>免费领取</div>
                </div>
<!--                <span class="btn-loot-all active" v-else-if="product.state == states.normal" @click="purchase">{{ product.price > 0 ? '马上抢' : '免费领取' }}</span>-->
                <span class="btn-loot-all btn-loot-sess" v-else-if="product.state == states.sellout">已售罄</span>
                <span class="btn-loot-all btn-loot-sess" v-else-if="product.state == states.offline">已结束</span>
                <div class="btn-loot-all hollow" v-else-if="! product.raffle.subscribe_start_active">抽签活动倒计时 {{ prefixZero(product.raffle.diff.hour) }}:{{ prefixZero(product.raffle.diff.minute) }}:{{ prefixZero(product.raffle.diff.second) }}</div>
                <template v-else-if="! product.raffle.subscribe_end_active">
                    <div class="btn-loot-all hollow" v-if="product.raffle.timeline.inform && subscribe">{{ product.raffle.subscribe_type ? '预约成功等待抽签' : '未预约等待抽签' }}</div>
                    <div class="btn-loot-all active" v-else-if="product.raffle.timeline.inform && ! subscribe" @click="toggleProductSubscribe">立即预约</div>
                    <div class="btn-loot-all subscribe hollow" v-else-if="subscribe">
                        <div>
                            <p class="title">{{ product.raffle.subscribe_type ? (product.raffle.is_hint ? '已中签' : '未中签') : '未预约' }}</p>
                            <p class="subtitle tip">{{ (product.raffle.is_hint || priority) ? '请等待' + dateFormat('mm-dd HH:ii', product.raffle.timeline.priority) + '开放优先购买' : '您可以在' + dateFormat('mm-dd HH:ii', product.raffle.timeline.release) + '统一抢购' }}</p>
                        </div>
                    </div>
                    <div class="btn-loot-all active" v-else @click="toggleProductSubscribe">立即预约</div>
                </template>
                <div class="btn-loot-all hollow" v-else-if="! product.raffle.inform_active">等待中签</div>
                <div class="btn-loot-all subscribe hollow" v-else>
                    <div>
                        <p class="title">{{ product.raffle.subscribe_type ? (product.raffle.is_hint ? '已中签' : '未中签') : '未预约' }}</p>
                        <p class="subtitle tip">{{ (product.raffle.is_hint || priority) ? '请等待' + dateFormat('mm-dd HH:ii', product.raffle.timeline.priority) + '开放优先购买' : '您可以在' + dateFormat('mm-dd HH:ii', product.raffle.timeline.release) + '统一抢购' }}</p>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="btn-loot-all active subscribe" v-if="product.state == states.waiting" @click="toggleProductSubscribe">
                    <div>
                        <p class="title">{{ subscribe ? '预约成功' : '立即预约' }}</p>
                        <p class="subtitle">距开始还有 {{ prefixZero(product.diff.hour) }}:{{ prefixZero(product.diff.minute) }}:{{ prefixZero(product.diff.second) }}</p>
                    </div>
                </div>
                <span class="btn-loot-all btn-loot-sess" v-else-if="product.state == states.sellout">已售罄</span>
                <span class="btn-loot-all btn-loot-sess" v-else-if="product.state == states.offline">已结束</span>
                <div class="btn-loot-all subscribe hollow in-app"
                     :style="{'color': product.color}"
                     @click="purchase"
                     v-else>
                    <div v-if="product.price > 0">
                        <p class="title">马上抢</p>
                        <p class="subtitle tip" v-if="!client.xinhua">在新华网客户端内购买</p>
                    </div>
                    <div v-else>免费领取</div>
                </div>
<!--                <span class="btn-loot-all active" v-else @click="purchase">{{ product.price > 0 ? '马上抢' : '免费领取' }}</span>-->
            </template>
        </div>

        <!-- 登陆弹框 -->
        <div class="login" :class="[{ none: true }]">
            <div class="succ-box">
                <div class="close" @click="showLog = false"></div>
                <div class="words">
                    <div>
                        <p>只有登录用户才能参与活动</p>
                    </div>
                </div>
                <router-link to="/login">
                    <div class="is-btn btn-go-login" @click="goLog">去登录</div>
                </router-link>
            </div>
        </div>

        <!-- 星火链介绍 底部弹框 -->
        <div class="xhl-desc-box" :class="{hide: ! supportShow}">
            <div class="close-xhl-toast" @click="supportShow = false"></div>
            <div class="xhl-desc">
                <div class="xhl-gfsq">官方授权</div>
                <p style="margin-bottom: 16px">
                    该藏品已获得版权方官方授权，由新华数藏平台代理发行。
                </p>
                <div class="xhl-jszc">
                    <img
                        class="xhl-wang"
                        src="@/assets/images/xhl-wang.png"
                        alt=""
                    />
                    <div>技术支持</div>
                </div>
                <p style="margin-bottom: 16px">
                    本期新华数藏数字藏品是基于「新华·星火链」技术协议发行的数字商品。「新华·星火链」基于中国信通院牵头建设的国家级区块链新型基础设施"星火·链网"数字原生资产（DNA）服务网络，支撑新华数藏发行。本期发布的每个数字藏品在「新华·星火链」都有链上唯一标识，且不可篡改。「新华·星火链」为本期数字藏品的发行交易提供底层区块链技术支持，为本平台提供可信存证技术、数字商品凭证技术服务。
                </p>
                <div class="xhl-xlfx">限量发行</div>
                <p>
                    所有数字藏品均为限量发售，每个数字藏品均持有独一无二的所有权凭证——星火·链网BID。新华数藏将致力于为数字收藏爱好者建立安全可靠、优质有趣的数字藏品平台，满足广大用户对数字藏品的收藏、欣赏和分享需求。
                </p>
            </div>
        </div>
    </template>
</template>

<script src="./Page.js"></script>

<style src="./Page.scss" lang="scss" scoped></style>